import React, { Component } from 'react'

export default ChartComponent => (
  class ResponsiveChart extends Component {
    constructor(props) {
      super(props)

      this.state = {
        containerWidth: null,
      }

      this.fitParentContainer = this.fitParentContainer.bind(this)
      this.resizeTimeout = null
    }

    componentDidMount() {
      this.fitParentContainer()
      window.addEventListener('resize', this.handleResize)
      // Also observe container size changes with ResizeObserver if available
      if (window.ResizeObserver && this.chartContainer) {
        this.resizeObserver = new ResizeObserver(() => {
          this.fitParentContainer()
        })
        this.resizeObserver.observe(this.chartContainer)
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize)
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout)
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      }
    }

    handleResize = () => {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout)
      }
      this.resizeTimeout = setTimeout(() => {
        this.fitParentContainer()
      }, 150)
    }

    fitParentContainer() {
      if (!this.chartContainer) return

      const { containerWidth } = this.state
      const currentContainerWidth = this.chartContainer
        .getBoundingClientRect().width

      const shouldResize = containerWidth !== currentContainerWidth && currentContainerWidth > 0

      if (shouldResize) {
        this.setState({
          containerWidth: currentContainerWidth,
        })
      }
    }

    renderChart() {
      const parentWidth = this.state.containerWidth

      return (
        <ChartComponent {...this.props} parentWidth={parentWidth} />
      )
    }

    render() {
      const { containerWidth } = this.state
      const shouldRenderChart = containerWidth !== null

      return (
        <div
          ref={(el) => { this.chartContainer = el }}
          className="Responsive-wrapper"
          data-testid="responsivewrapper"
        >
          {shouldRenderChart && this.renderChart()}
        </div>
      )
    }
  }
)
